import * as React from 'react';

export const LazyRTOKnowledgeQuestion = React.lazy(() => import('./component'));
